import { render, staticRenderFns } from "./preferences.card.vue?vue&type=template&id=d0aaa016&"
import script from "./preferences.card.vue?vue&type=script&lang=ts&"
export * from "./preferences.card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports